<template>
    <div id="contendor-principal-cancelacionDeCedula">
        <div id="contenedor-encabezados-cancelacionDeCedula" class="text-left">
            <h1>CANCELACIÓN DE CÉDULA</h1>
            <!-- <h3>Ingrese la información requerida para cancelar una nueva cedula</h3> -->
         </div>
         <div id="encabezado-contenedor-contenido" class="form-inline mt-3">
            <div v-if="!esCancelar && cedulaEncontrada" class="flex-grow-1"><button type="button" @click="limpiarFormulario" class="btn btn-primary"><i class="fas fa-long-arrow-alt-left" style="font-size:20px;"></i></button></div>
            <div v-if="!esCancelar && cedulaEncontrada" class="flex-grow-1" style="padding-left: 11em;"><h4>Cancelación</h4></div>
            <div v-if="!esCancelar && cedulaEncontrada" class="flex-grow-1"></div>
            <div v-if="esCancelar" class="flex-grow-1 pl-3"><h4>Búsqueda de cédula</h4></div>
        </div>
         <div id="contenedor-cancelacion" class="col-12 area">
             <!-- <h3>Ingrese la información requerida para buscar y cancelar una cedula</h3> -->
             <div v-if="esCancelar" class="d-flex justify-content-between mt-2">
                <div id="filtros-cancelacioCedula" style="width: 65%">
                    <FiltrosDeBusqueda class="contenedor-color-negro"
                        :catalogos="filtrosDeBusqueda" 
                        :ejecutaLaFuncion="evtBuscarCedula" 
                        :filtrosEstablecidos="filtrosEstablecidos"
                        :tituloDeBusqueda="'Paso 1: Busque la cédula con ayuda de los filtros'"
                        :ref="REF_FILTROS_BUSQUEDA"
                        :key="'FBVCC' + contRender"></FiltrosDeBusqueda>
                </div>
                <div class="contenedor-color-negro contenedor-color-gris d-flex align-items-center justify-content-center" style="width: 33%">
                    <div>
                        <div id="icono-estatus-busqueda" class="d-flex justify-content-center">
                            <i v-if="busquedaCedula" class="fas fa-archive" style="color: var(--verde-pj-100);"></i>
                            <i v-if="!busquedaCedula" class="fas fa-file-alt" style="color: var(--verde-pj-100);"></i>
                        </div>
                        <div id="estatus-busqueda-expediente" class="d-flex justify-content-center align-items-center">
                            <div class="d-flex">
                                <h4 v-if="busquedaCedula"><i class="fas fa-search"></i> Buscar cédula</h4>
                                <h4 v-if="cedulaEncontrada">Cédula encontrada: <i class="fas fa-check-circle text-success"></i></h4>
                                <h4 v-if="!cedulaEncontrada && !busquedaCedula">No se encontró cédula: <i class="fas fa-times-circle text-danger"></i></h4>
                            </div>
                        </div>
                    </div>
                </div>
             </div>
             <div v-if="!esCancelar && cedulaEncontrada" id="contenedor-cancelacion-cedula" class="d-flex justify-content-between mt-2">
                 <CDescripcionBasicaDeCedula class="contenedor-color-negro" style="width: 59%" id="prbfvf"
                        :idDelInput="'descripcionCedulaVCC'"
                        :cedula="cedulaBD"
                        :conVisualizadorDeDocumento="true"
                        :conSalidasYConstituciones="false"></CDescripcionBasicaDeCedula>
                 <div id="a-ancelacion" class="contenedor-color-negro align-middle" style="width: 39%;">
                     <div id="i-accion-cancelacion" style="margin-top: 3em;">
                        <i id="i-cedula" class="fas fa-file-alt" style="font-size: 20em;"></i>
                        <i id="i-cancelar" class="fas fa-ban text-danger" style="font-size: 16em;"></i>
                     </div>
                     <div style="margin-top: 10px; margin-right: 10px; margin-left: 10px; height: 70px;">
                        <button @click="evtCancelarCedula" type="button" class="btn btn-primary"><i class="fas fa-ban"></i>&nbsp;&nbsp;Cancelar cédula</button>
                    </div>
                 </div>
             </div>
             <div :class="[esCancelar ? 'd-flex justify-content-end mt-4' : 'd-flex mt-4']">
                <button v-if="esCancelar && cedulaEncontrada" type="button" class="btn btn-primary" @click="irCancelar">Ir a cancelar&nbsp;&nbsp;<i class="fas fa-arrow-circle-right"></i></button>
                <!-- <button v-if="!esCancelar && cedulaEncontrada" type="button" class="btn btn-primary" @click="limpiarFormulario"><i class="fas fa-arrow-circle-left"></i>&nbsp;&nbsp;Regresar</button> -->
            </div>
         </div>
         <!-- MODAL PARA MOSTRA TABLA DE CEDULAS ENCONTRADAS -->
        <div class="modal align-middle visor-documento" tabindex="-1" data-backdrop="static" data-keyboard="false" id="eleccion-cedula-VCSDD">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div id="modal-cedulas" class="modal-content">
                    <div class="modal-header">
                        <!-- <i class="fas fa-info-circle"></i>&nbsp;Se -->
                        <h5 class="modal-title">LA BÚSQUEDA OBTUVO VARIAS CÉDULAS</h5>
                        <button id="'btn-cerrar-eleccion-cedula-VCSDD" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                    </div>
                    <div class="modal-body" style="padding: 25px 30px 25px 30px;">
                        <div v-if="cedulasEncontradasTabla.length > 0" class="contenedor-color-negro">
                            <h5><i class="fas fa-info-circle"></i>&nbsp; Seleccione una cédula</h5>
                            <TablaGenericaCedulas class="table-responsive"
                                :idDelInput="'T-cedulas-VCSDD'" 
                                :encabezadosColumnas="encabezadosColumnas" 
                                :accionesEnTabla="tablaAcciones" 
                                :listaDeCedulas="cedulasEncontradasTabla"
                                :conResponsive="true"
                                v-on:accionesFuncionElegir="evtEleccionDeCedula"></TablaGenericaCedulas>
                        </div>
                    </div>  
                </div>
            </div>
        </div>
         <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="formulario-cancelacion">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Formulario de cancelación</h5>
                        <button id="btn-cerrar-formulario-cancelacion" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                    </div>
                    <div class="modal-body">
                        <div class="contenedor-color-negro">
                            <div class="form-group">
                                <h6 for="motivos-cancelacion" style="color: black;">Motivo(s) de cancelación (*)</h6>
                                <textarea id="motivos-cancelacion" v-model="motivosDeCancelacion" type="text" rows="6" class="form-control campo-motivos-cancelacion" placeholder="Ingrese el o los motivos por los que se cancelara la cedula" />  
                            </div>
                        </div>
                        <div :class="[(mostrarMsjErrorFormulario) ? 'mt-4 form-inline justify-content-between' : 'mt-4 form-inline justify-content-end']">
                            <i v-if="mostrarMsjErrorFormulario">*Debes ingresar un motivo</i>
                            <button type="button" class="btn btn-primary" @click="evtCancelacionDeCedula">Cancelar cédula</button>
                        </div>
                    </div>  
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import enumeraciones from '@/../static/js/enumeraciones'
import sistemas from '@/../static/js/sistemas'
import api from '@/../static/js/api'
import axios from 'axios'
import comun from "@/../static/js/comun"


export default {
    components: {
        FiltrosDeBusqueda: sistemas.SINOJ.FiltrosDeBusqueda,
        CDescripcionBasicaDeCedula: sistemas.SINOJ.CDescripcionBasicaDeCedula,
        TablaGenericaCedulas: sistemas.SINOJ.CTablaGenericaCedulas
    },
    data() {
        return {
            motivosDeCancelacion: '',
            COMPONENTE_DESCRIPCION_CEDULA_ID: 'contenedor-descripcion-cedula',
            REF_FILTROS_BUSQUEDA: 'REFFBVCC',
            ACCIONES_DESCRIPCION_CEDULA: { mostrar: true, cambiar: true},
            DESCRIPCION_CEDULA_ENCABEZADO: 'Cedula ',
            mostrarCedulaYformulario: false,
            filtrosDeBusqueda: [
                { 
                    catalogoId: 'filtroNumeroFolio',
                    idDelInput: 'inputNumeroFolioEnvioDeCedula'
                },
                { 
                    catalogoId: enumeraciones.catalogos.Consecutivo, 
                    idDelInput: 'inputjuzgadoEnvioDeCedula' 
                }, 
                { catalogoId: enumeraciones.catalogos.Materias, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'f-tMateria-VCDC' },
                { 
                    catalogoId: enumeraciones.catalogos.Juzgados, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione,
                    idDelInput: 'catalogoJuzgadoEnvioDeCedula'
                },
                {   catalogoId: enumeraciones.catalogos.TiposDeDocumentos, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'f-tDocumento-VCDC' },
                { catalogoId: enumeraciones.catalogos.NumeroExtra, idDelInput: 'f-nExtra-VCDC' }
            ],
            encabezadosColumnas: ['Folio','Fecha de registro', 'Tipo de cedula','Estatus', 'Resultado', ''],
            tablaAcciones: { motrarAcciones: true, check: false, eliminar: false, detalles: false, ver: false, elegir: true},
            cedulasEncontradasTabla: [],
            cedulasEncontradasBD: [],
            filtrosEstablecidos: {},
            busquedaCedula: true,
            cedulaEncontrada: false,
            esCancelar: true,
            cedulaBD: null,
            contRender: 0,
            conatdorRenderPrueba: 0,
            FORMATO_FECHA: "YYYY-MM-DD HH:mm:ss",
            cargoAreaDeUsuario: false,
            materiaPenalId: -1,
            mostrarMsjErrorFormulario: false
        }
    },
    methods: {
        evtCancelacionDeCedula: function() {
            if(this.campoRequeridoEsValido(this.motivosDeCancelacion)) {
                $('#formulario-cancelacion').modal('hide');
                this.informarConfirmacionDeCancelacion(this.cedulaBD.CedulaId);
            }
            else {
                this.mostrarMsjErrorFormulario = true;
            }
        },
        evtEleccionDeCedula: function(evento) {
            this.cedulaBD = null;
            const CEDULA_SELECCIONADA = evento.target.getAttribute('id');
            const ID_CEDULA = parseInt(this.obtenerCedula(CEDULA_SELECCIONADA));
            this.cedulasEncontradasBD.filter(cDB => cDB.CedulaId == ID_CEDULA).forEach(c => {
                this.cedulaBD = c;
                this.asignarValoresEnFiltros();
            });
        },
        asignarValoresEnFiltros: function() {
            this.busquedaCedula = false;
            this.cedulaEncontrada = true;
            this.esCancelar = true;
            this.$refs[this.REF_FILTROS_BUSQUEDA].numeroDeFolio = this.cedulaBD.CedulaId;
            // valores de expediente
            if(this.campoRequeridoEsValido(this.cedulaBD.Expediente)) {
                let { Materia, Consecutivo, TipoDocumento, Juzgado, NumeroDeDocumento } = this.cedulaBD.Expediente;
                this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_Area.areaId = Juzgado.JuzgadoId;
                this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_Materia.materiaId = Materia.MateriaId;
                this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_TipoDocumento.tipoDocumentoId = TipoDocumento.TipoDocumentoId;
                if(TipoDocumento.TipoDocumentoId == enumeraciones.pj.tiposDocumento.Terceria || TipoDocumento.TipoDocumentoId == enumeraciones.pj.tiposDocumento.Incidente) {
                    this.$refs[this.REF_FILTROS_BUSQUEDA].numeroExtra = Consecutivo;
                    this.$refs[this.REF_FILTROS_BUSQUEDA].mostrarNumeroExtra = true;
                }
                this.$refs[this.REF_FILTROS_BUSQUEDA].consecutivo = NumeroDeDocumento; 

                // se renderizan los catalogos
                this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_Materia.key = 'CFMTVCD' + this.contRender;
                this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_Area.key = 'CFJZVCD' + this.contRender;
                this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_TipoDocumento.key = 'CFTDVCD' + this.contRender;
            }
            $('#eleccion-cedula-VCSDD').modal('hide');
        },
        obtenerCedula: function(cedulaSeleccionada) {
            const CEDULA = cedulaSeleccionada.split('-');
            const POSICION_ID = (CEDULA.length - 1);
            const ID_CEDULA = CEDULA[POSICION_ID];
            return ID_CEDULA;
        },
        limpiarFormulario: function() {
            this.esCancelar = true;
            this.motivosDeCancelacion = null;
            this.cedulaBD = null;
            this.busquedaCedula = true;
            this.cedulaEncontrada = false;
            this.$nextTick(() => {
                this.asignarValoresDeUsuario(this.$store.state.Login_Usuario.Area);
            });
            this.contRender ++;
            this.mostrarMsjErrorFormulario = false;
        },
        evtCancelarCedula: function() {
            $('#formulario-cancelacion').modal('show');
        },
        irCancelar: function() {
            this.esCancelar = false;
        },
        hayUnFiltroParaBusqueda: function() {
            let existeFiltro = false;
            const FILTROS_BUSQUEDA = [this.$refs[this.REF_FILTROS_BUSQUEDA].numeroDeFolio, this.$refs[this.REF_FILTROS_BUSQUEDA].consecutivo, this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_Area.areaId];
            for(let i=0; i<FILTROS_BUSQUEDA.length; i++) {
                if(this.campoRequeridoEsValido(FILTROS_BUSQUEDA[i])) {
                    existeFiltro = true;
                    break;
                }
            }
            return existeFiltro;
        },
        cancelarCedulaBD: function() {
            const SERVIDOR = api.conexion;
            const METODO_API_CANCELAR = api.SINOJ.sistema.cedulas.cancelacion.CancelacionDeCedula;
            let urlApi = SERVIDOR + METODO_API_CANCELAR;
            let peticionArchivos = false;
            let peticionAPI = {
                Cedula: {
                    CedulaId: this.cedulaBD.CedulaId,
                    MotivoDeCancelacion: this.motivosDeCancelacion
                }
            }
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
            $('#formulario-cancelacion').modal('hide');
            comun.SeEstaCargandoInformacion(true);
            axios.post(urlApi, peticionAPI, headerPeticion)
                    .then(respuesta => {            
                        if (respuesta.data.SiHayError) {
                            let mensajeError = respuesta.data.Error.Mensaje;
                            console.log(respuesta.data.Error);
                            comun.mensajeDeAlerta(mensajeError, null, null);
                            //$('#formulario-cancelacion').modal('show');
                            this.motivosDeCancelacion = null;
                        } 
                        else {
                            comun.mensajeDeAlerta(respuesta.data.Satisfactorio);
                            this.limpiarFormulario();
                        }
                        comun.SeEstaCargandoInformacion(false);
                    })
                    .catch(excepcion => {
                        comun.SeEstaCargandoInformacion(false);
                        console.log(excepcion);
                        comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                    }
            ); 
        },
        buscarCedulaBD: function() {
            const SERVIDOR = api.conexion;
            const METODO_API_OBTENER = api.SINOJ.sistema.cedulas.cancelacion.ObtenerCedulaParaCancelacion;
            let urlApi = SERVIDOR + METODO_API_OBTENER;
            let peticionArchivos = false;
            let peticionAPI = {
                CedulaId: this.campoRequeridoEsValido(this.$refs[this.REF_FILTROS_BUSQUEDA].numeroDeFolio) ? this.$refs[this.REF_FILTROS_BUSQUEDA].numeroDeFolio : null,
                MateriaId: this.campoRequeridoEsValido(this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_Materia.materiaId) ? this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_Materia.materiaId : null,
                TipoDeDocumentoId: this.campoRequeridoEsValido(this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_TipoDocumento.tipoDocumentoId) ? this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_TipoDocumento.tipoDocumentoId : null,
                Consecutivo: this.campoRequeridoEsValido(parseInt(this.$refs[this.REF_FILTROS_BUSQUEDA].numeroExtra)) ? parseInt(this.$refs[this.REF_FILTROS_BUSQUEDA].numeroExtra) : null,
                NumeroExpediente: this.campoRequeridoEsValido(this.$refs[this.REF_FILTROS_BUSQUEDA].consecutivo) ? this.$refs[this.REF_FILTROS_BUSQUEDA].consecutivo : null,
                JuzgadoId: this.campoRequeridoEsValido(this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_Area.areaId) ? this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_Area.areaId : null,
                esPrueba: false
            }
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
            comun.SeEstaCargandoInformacion(true);
            axios.post(urlApi, peticionAPI, headerPeticion)
                    .then(respuesta => {            
                        if (respuesta.data.SiHayError) {
                            let mensajeError = respuesta.data.Error.Mensaje;
                            console.log(respuesta.data.Error);
                            comun.mensajeDeAlerta(mensajeError, null, null);
                        } 
                        else {
                            this.cedulasEncontradasBD = respuesta.data.Cedulas;
                            this.cedulasEncontradasTabla = [];
                            if(this.cedulasEncontradasBD != null && this.cedulasEncontradasBD.length > 0) {
                                this.evaluarBusquedaCedula();
                            }
                            else {
                                this.busquedaCedula = false;
                                this.cedulaEncontrada = false;
                            }
                        }
                        comun.SeEstaCargandoInformacion(false);
                    })
                    .catch(excepcion => {
                        comun.SeEstaCargandoInformacion(false);
                        console.log(excepcion);
                        comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                    }
            ); 
        },
        evaluarBusquedaCedula: function() {
            if(this.cedulasEncontradasBD.length == 1) {
                this.cedulaBD = this.cedulasEncontradasBD[0];
                //console.log(this.cedulaBD);
                this.busquedaCedula = false;
                this.cedulaEncontrada = true;
                this.esCancelar = true;
            }
            else {
                this.cedulasEncontradasTabla = this.darFormatoCedulasTabla(this.cedulasEncontradasBD);
                $('#eleccion-cedula-VCSDD').modal('show');
            }
        },
        /**
         * Metodo encargado de dar formato a objetos de cedula al formato
         * [Folio,Fecha de creacion, Tipo de cedula] que ocupa la
         * tabla de la vista. 
         * @param {object} cedulas [fuente de datos de cedulas]
         * @see {@link cedulaAObjetoTabla}
         */
        darFormatoCedulasTabla: function(cedulas) {
            let cedulasConFormato = [];
            cedulasConFormato = cedulas.map(c => {
                let cedula = this.cedulaAObjetoTabla(c);
                return cedula;
            });
            return cedulasConFormato;
        },
        cedulaAObjetoTabla: function(cedula) {
            let cedulaObjTabla = {};
            cedulaObjTabla.Folio = cedula.CedulaId;
            cedulaObjTabla.FechaDeRegistro = moment(cedula.FechaDeRegistro).format(this.FORMATO_FECHA);
            cedulaObjTabla.TipoCedula = this.campoRequeridoEsValido(cedula.TipoCedula.Nombre) ? cedula.TipoCedula.Nombre.trim() : 'Sin tipo de cedula';
            cedulaObjTabla.Estatus = cedula.Estatus.Nombre; 
            cedulaObjTabla.Resultado = (cedula.Resultado != null) ? cedula.Resultado.TipoResultado.Nombre : 'Sin resultado';
            return cedulaObjTabla;
        },
        campoRequeridoEsValido: function(campo) { 
            let esValido = false
            if(typeof campo === 'string' || campo instanceof String) {
                // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
                if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'number' || campo instanceof Number) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo > 0) {
                    esValido = true;
                }
            }
            else {
                if (campo != null && campo != undefined) {
                    esValido = true;
                }
            }
            return esValido;
        },
        informarConfirmacionDeCancelacion: function (cedulaId) {
            bootbox.confirm({
            title: "Mensaje del sistema",
            message: `Estas seguro que deseas cancelar la cedula [ folio: #${cedulaId} ]<br>¿Desea continuar?`,
            buttons: {
                cancel: {
                    label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                },
                confirm: {
                    label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
                }
            },
            callback: (respuesta) => {
                if (respuesta) {
                    this.cancelarCedulaBD();
                }
                else {
                    $('#formulario-cancelacion').modal('show');
                }
            }
            });
        },
        /**
         * funcion para cambiar de cedula
         * @param {object} evento [evento emitido por componente hijo CDescripcionBasicaDeCedula {@link #COMPONENTE_DESCRIPCION_CEDULA_ID}]
         */
        cambiarCedula: function(evento) {
            $("#" + 'filtros-cancelacioCedula').removeClass("desabilitar-contenedor-buscarCedula");
            this.mostrarCedulaYformulario = false;
        },
         /**
         * funcion para realizar la cancelacion de la cedula
         */
        cancelarCedula: function() {
            //console.log('el::valordeledotroe::es::' + this.contenidoDelEditor)
        },
         /**
         * funcion para realizar busqueda de una cedula
         * @param {object} evento [evento emitido por componente hijo CBusquedaDeCedula {@link #COMPONENTE_BUSQUEDA_CEDULA_ID}]
         */
        evtBuscarCedula: function() {
            /* if(this.hayUnFiltroParaBusqueda())
                this.buscarCedulaBD();
            else
                comun.mensajeDeAlerta('para realizar la busqueda debes tener al menos un filtro valido en el paso 1.'); */
            this.busquedaCedula = true;
            this.cedulaEncontrada = false;
            this.buscarCedulaBD();
        },
        asignarValoresDeUsuario: function(areaDeUsuario) {
             // se asignan los valores del usuario (en mounted y no en created porque es hasta que este creada la instancia del componente FiltrosDeBusqueda)
            if(this.campoRequeridoEsValido(areaDeUsuario)) {
                const { AreaId } = areaDeUsuario;
                this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_Area.esInformativo = this.campoRequeridoEsValido(AreaId) ? true : false;
                this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_Area.areaId = this.campoRequeridoEsValido() ? AreaId : -1;
                this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_Area.key = 'CFJZVCD' + this.contRender;
                const VALOR_EVENTO = {
                    target: { value: this.campoRequeridoEsValido(AreaId) ? AreaId : -1 }
                };
                // se llama a funcion de evento correspondiente al catalogo de Area para que actualice los demas catalogos
                this.$refs[this.REF_FILTROS_BUSQUEDA].cambioDeArea(VALOR_EVENTO);
            }
        }
    },
    mounted() { 
        if(this.campoRequeridoEsValido(this.$store.state.Login_Usuario.Area)) {
            this.cargoAreaDeUsuario = true;
            this.asignarValoresDeUsuario(this.$store.state.Login_Usuario.Area);
        }
    },
    watch: {
        '$store.state.Login_Usuario.Area': function() {
            this.$nextTick(() => {
                if(this.campoRequeridoEsValido(this.$store.state.Login_Usuario.Area) && !this.cargoAreaDeUsuario) { 
                    this.cargoAreaDeUsuario = true;
                    this.asignarValoresDeUsuario(this.$store.state.Login_Usuario.Area);
                }
            });
        },
        motivosDeCancelacion() {
            this.mostrarMsjErrorFormulario = false;
        }
    }
}
</script>
<style scoped>
@media only screen and (max-width: 1100px) {
  #icono-estatus-busqueda i{
    font-size: 14em !important;
  }

  #i-cedula {
      font-size: 16em !important;
  }

  #i-cancelar {
    font-size: 14em !important;
  }

  #a-ancelacion .btn {
    font-size: 1.5em !important;
  }
}

@media only screen and (max-width: 900px) {
    #icono-estatus-busqueda i{
        font-size: 10em !important;
    }

    #estatus-busqueda-expediente h4 {
        font-size: 5px !important;
    }

    #i-cedula {
      font-size: 12em !important;
    }

    #i-cancelar {
        font-size: 9em !important;
    }
}

@media only screen and (max-width: 1290px) {

    #estatus-busqueda-expediente h4 {
        font-size: 18px !important;
    }

    #estatus-busqueda-expediente {
        background-color: #1e2020;
        width: 250px !important;
        padding: 1em;
        border-radius: 8px;
    }
}

.modal-header {
    background-color: rgb(36, 34, 34);;
    border: none;
}

#a-ancelacion .btn {
    background-color: #1c1f1f;
    width: 100% !important;
    height: 100% !important;
    font-size: 2em;
}

#a-ancelacion .btn:focus, #a-ancelacion .btn:hover {
    background-color: black;
}

#encabezado-contenedor-contenido {
  background-color: var(--verde-pj);
  padding: 10px;
}

#encabezado-contenedor-contenido h4 {
  color: #ffff;
}

#encabezado-contenedor-contenido .btn {
  background-color: var(--verde-pj-100);
  padding-left: 15px;
  padding-right: 15px;
}

#i-accion-cancelacion {
    background-color: #434747;
    position: relative;
    height: 70%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    margin-left: 10px;
    margin-right: 10px;
    border-radius: 9px;
}

#i-cancelar {
    position: absolute;
    top: 90px;
}

#icono-estatus-busqueda i{
    font-size: 19em;
    margin-bottom: 20px;
}

.contenedor-color-negro {
    padding: 1.5em;
   /*  background-color: #2c2d31;
    box-shadow: 0px 6px 20px 8px #161616; */
}

.contenedor-color-gris {
    border: 1px solid rgba(143,142,142,0.75);
    box-shadow: -6px 7px 5px 0px rgba(143,142,142,0.75);
}
    
#contendor-cancelacion-cedula {
    display: flex;
}

#formulario-cancelacion {
    margin-top: 2em;
}

#campo-motivos-cancelacion {
    padding: 2px;
}

.desabilitar-contenedor-buscarCedula {
    pointer-events: none;
    opacity: 0.4;
}

 #estatus-busqueda-expediente {
    background-color: var(--gris-pj-100);
        border: 1px solid var(--gris-pj);
    width: 25em;
    padding: 1em;
    border-radius: 8px;
}

.margenes-accion-cancelar {
    margin: 6em 6em 6em 6em;
}

#contendor-principal-cancelacionDeCedula .area {
    background-color: var(--gris-pj-100);
    box-shadow: none;
}

#contendor-principal-cancelacionDeCedula .btn-primary {
    background-color: var(--verde-pj-100);
}

#contendor-principal-cancelacionDeCedula .modal-header {
    background-color: var(--verde-pj);
}

#contendor-principal-cancelacionDeCedula .modal-body {
    background-color: var(--gris-pj-100);
}
</style>


// WEBPACK FOOTER //
// src/components/SINOJ/Cedulas/ManejoDeCedulas/Cancelacion/CCancelacionDeCedula.vue